import { render, staticRenderFns } from "./AvisoSelecionarTerritorio.vue?vue&type=template&id=1ea0aff8&lang=pug"
import script from "./AvisoSelecionarTerritorio.vue?vue&type=script&lang=js"
export * from "./AvisoSelecionarTerritorio.vue?vue&type=script&lang=js"
import style0 from "./AvisoSelecionarTerritorio.vue?vue&type=style&index=0&id=1ea0aff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports